'use client';
import { useIsMobile } from '@/hooks/use-is-mobile';
import Image from 'next/image';
import { Button } from '../ui/button';

export const Banner = () => {
  const { isMobile } = useIsMobile();

  const scrollToSection = (elementId: string) => {
    const element = document.getElementById(elementId);

    if (element) {
      const offset = 280; // Adjust this value based on your needs
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  if (isMobile) {
    return (
      <div className='mb-[40px]'>
        <Image
          src='/warranty-page/warranty-banner-mobile.jpg'
          alt='warranty banner'
          width={750}
          quality={100}
          height={400}
          className='h-auto w-full'
          id='duration'
        />

        <div className='bg-[#F9F9F9] px-[12px] py-[20px]'>
          <h1 className='font-teko-medium text-[30px] font-medium leading-[28px] text-primary'>Lifetime Warranty</h1>
          <p className='mb-[10px] font-roboto-regular text-[16px] font-[400] leading-[24px] text-primary'>
            Your Journey, Our Commitment
          </p>
          <p className='mb-[20px] font-roboto-regular text-[16px] font-[400] leading-[24px] '>
            Every HISEA product is backed by our commitment to quality and built to support a lifetime of adventures.
          </p>

          <Button
            onClick={() => {
              scrollToSection('warranty-registeration');
            }}
            className=' h-[40px] w-full rounded-full bg-primary py-0 font-roboto-medium font-roboto-medium text-[18px] leading-[40px] text-white hover_bg-primary/90'
            href='/create-account'
          >
            Register Now
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div
      className='relative mb-[60px] w-full'
      // style={{
      //   backgroundImage: `url('/claim-warranty/banner.jpg')`,
      //   backgroundSize: 'cover',
      // }}
    >
      <Image
        src={'/claim-warranty/banner.jpg'}
        alt='affiliate-program'
        width={3840}
        height={740}
        className=' h-auto min-h-[200px] w-full object-cover lg_min-h-[370px]'
      />
      <div className='absolute left-0 top-0 h-full w-full'>
        <div className='container mx-auto flex h-full flex-col items-start justify-center'>
          <div
            id='duration'
            className='font-teko-medium text-[40px] font-medium uppercase leading-[40px] text-white'
            style={{ textShadow: '2px 2px 3px rgba(0, 0, 0, 0.5)' }}
          >
            Lifetime Warranty
          </div>
          <p
            className='mb-[40px] text-left font-roboto-regular text-[18px] font-medium leading-[24px] text-white'
            style={{ textShadow: '2px 2px 3px rgba(0, 0, 0, 0.5)' }}
          >
            Your Journey, Our Commitment
          </p>
          <p
            className='mb-[20px] text-left font-roboto-regular text-[18px] font-medium leading-[24px] text-white'
            style={{ textShadow: '2px 2px 3px rgba(0, 0, 0, 0.5)' }}
          >
            Every HISEA product is backed by our commitment to quality and built to support a lifetime of adventures.
          </p>
          <Button
            className='h-[50px] w-[180px] rounded-full bg-white py-0 text-center font-roboto-medium text-[18px] leading-[50px] text-black hover_bg-[#000] hover_text-white'
            onClick={() => {
              scrollToSection('warranty-registeration');
            }}
          >
            Register Now
          </Button>
        </div>
      </div>
    </div>
  );
};
